import { createRoot } from 'react-dom/client'
import './index.css'
import 'katex/dist/katex.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(<App />)
